<template>
  <el-tooltip content="AskMatthew" placement="bottom">
    <el-button circle style="width: 35px; height: 35px" @click="toggleHelpWindow">
      <fa-icon :icon="faQuestionCircle" class="text-[16px]" />
    </el-button>
  </el-tooltip>
  <Teleport to="body">
    <AskMathewBotWindow
      v-if="isHelpWindowOpen && isUserLoggedIn"
      :user-profile="userProfile"
      @close="toggleHelpWindow"
    />
  </Teleport>
</template>

<script>
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

import { useUserProfile } from '@/api/use-user-profile.js'
import AskMathewBotWindow from '@/components/Global/AskMathewBotWindow.vue'

export default {
  name: 'Help',
  components: {
    AskMathewBotWindow,
  },
  setup() {
    const isHelpWindowOpen = ref(false)
    const store = useStore()
    const userId = store.state.globalComponents.userId
    const { isLoading, isError, data: userProfile } = useUserProfile()
    // Computed property to check if the user is logged in (userId is not null)
    const isUserLoggedIn = computed(() => userId !== null)
    const toggleHelpWindow = () => {
      isHelpWindowOpen.value = !isHelpWindowOpen.value
    }
    return {
      faQuestionCircle,
      isLoading,
      isError,
      userProfile,
      toggleHelpWindow,
      isHelpWindowOpen,
      isUserLoggedIn,
    }
  },
}
</script>
